import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import history from './history';
import { Layout, WysywgPage, ErrorRedirect } from './../components';
import {
  Home,
  GalleryList,
  About,
  Contact,
  BlogLanding,
  NoMatch,
  PhotoLanding,
  FilmLanding,
  FineArtLanding,
  PublicationsLanding,
  SinglePortfolio,
  SingleFilm,
  SinglePublication,
  SingleExhibition,
  SingleArticle
} from './../pages';

const Routes = (props) => (
  <Router history={history}>
    <Route render={({ location, match }) => (
      <Layout routeData={location} matchData={match}>
        <Switch>
          <Route exact path='/' component={props => <Home {...props}/>}/>
          <Route path='/photography' component={PhotoLanding}/>
          <Route path='/film' component={FilmLanding}/>
          <Route path='/fine-art' component={FineArtLanding}/>
          <Route path='/publications' component={PublicationsLanding}/>
          <Route path='/journal' render={ routeProps => (<BlogLanding {...routeProps} data={props.staticContent.blogLanding.data}/>)}/>
          <Route path='/studio-conversations' render={ routeProps => (<BlogLanding {...routeProps}  data={props.staticContent.conversationsLanding.data}/>)}/>
          <Route exact path='/galleries' render={ routeProps => (<GalleryList {...routeProps} data={props.staticContent.galleryData.data} />)}/>
          <Route exact path='/about' render={ routeProps => (<About {...routeProps} data={props.staticContent.aboutData.data} />)}/>
          <Route exact path='/contact' render={ routeProps => (<Contact {...routeProps} data={props.staticContent.aboutData.data} />)}/>
          <Route exact path='/terms' render={ routeProps => (<WysywgPage {...routeProps} data={props.staticContent.termsData.data} />)}/>
          <Route exact path='/portfolio/:pageSlug' component={props=> <SinglePortfolio {...props}/>}/>
          <Route exact path='/films/:pageSlug' component={props => <SingleFilm {...props}/>}/>
          <Route exact path='/publication/:pageSlug' component={props => <SinglePublication {...props}/>}/>
          <Route exact path='/exhibition/:pageSlug' component={props => <SingleExhibition {...props}/>}/>
          <Route exact path="/article/:pageSlug" component={props => <SingleArticle {...props} postType={'post'}/>}/>
          <Route exact path="/studio-conversation/:pageSlug" component={props => <SingleArticle {...props} postType={'studio-conversations'}/>}/>
          <Route path="/404" component={NoMatch}/>
          <Route component={ErrorRedirect}/>
        </Switch>
      </Layout>
    )}/>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/router/index.js